import { httpGet } from './apiService';
import { LanguageEntityAdminApiService } from './languageEntityAdminApiService';

export class NavigationEntityAdminApiService<Entity> extends LanguageEntityAdminApiService<Entity> {
    public constructor(baseUrl: string) {
        super(baseUrl);
    }

    public async duplicate(id: number): Promise<Entity | undefined> {
        const response = await httpGet(`${this.baseUrl}/duplicate/${id}`);

        return this.returnResult(await response.json());
    }
}
